export default {
  data() {
    return {
      isScroll: false,
    };
  },

  mounted() {
    const element = document.getElementById('contentWrapper');
    element.addEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll(e) {
      const { scrollTop } = e.srcElement;
      if (scrollTop > 50) this.isScroll = true;
      else this.isScroll = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/form-ui-v2/jMixScroll.js